var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrganizationBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_539_653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 21.875H21.875",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.33337H10.4167",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.5H10.4167",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 16.6666H10.4167",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 8.33337H15.625",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 12.5H15.625",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 16.6666H15.625",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20831 21.875V5.20833C5.20831 4.6558 5.42781 4.12589 5.81851 3.73519C6.20921 3.34449 6.73911 3.125 7.29165 3.125H17.7083C18.2608 3.125 18.7908 3.34449 19.1815 3.73519C19.5722 4.12589 19.7916 4.6558 19.7916 5.20833V21.875",
    stroke: "black",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_539_653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganizationBlack);
export default __webpack_public_path__ + "static/media/Icon_Organization_Black.cf8b912571f08fa8832c76296fe635ba.svg";
export { ForwardRef as ReactComponent };